import { render, staticRenderFns } from "./SentimentHot.vue?vue&type=template&id=8d2f78b8&scoped=true"
import script from "./SentimentHot.vue?vue&type=script&lang=js"
export * from "./SentimentHot.vue?vue&type=script&lang=js"
import style0 from "./SentimentHot.vue?vue&type=style&index=0&id=8d2f78b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2f78b8",
  null
  
)

export default component.exports